module.exports = __webpack_public_path__ + "Book_mockup_gribou.png?896d8fc0b3131755524a5cf836f2274e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Book_mockup_gribou.png
// module id = 56
// module chunks = 0